import { cn } from '@forest/shared'
import { useStore } from '@nanostores/react'
import { m } from '~/paraglide/messages'
import { $serviceLevelStatus } from '~/store/service-level-status'
import { CheckIcon } from './icons/check-icon'
import { NotIncludedIcon } from './icons/not-included-icon'

export function ComparisonTable(props: { className?: string }) {
  const serviceLevelStatus = useStore($serviceLevelStatus)
  const isProUser = serviceLevelStatus?.is_premium

  return (
    <div className={cn('w-full', props.className)}>
      <div className="relative flex w-full flex-col">
        <div className="pointer-events-none absolute bottom-0 right-[-6px] top-0 w-[69px] rounded-[10px] bg-white/20"></div>

        <div className="flex h-[34px] items-center justify-end">
          <div className="flex items-center gap-4">
            <span className="w-11 text-center text-sm font-semibold text-white">
              {isProUser ? m.pro() : m.free()}
            </span>
            <span className="flex h-[22px] w-[57px] items-center justify-center rounded border-[2px] border-white bg-gradient-to-r from-[#81D200] via-[#0EBC73] to-[#08C1F3] text-center text-xs font-bold text-white">
              {'PLUS'}
            </span>
          </div>
        </div>

        {(isProUser ? featuresForProUser : featuresForFreeUser).map(
          (feature, index) => (
            <div
              key={index}
              className="flex h-[46px] items-center justify-between border-white/30 [&:not(:last-child)]:border-b"
            >
              <span className="text-sm text-white">{feature.name}</span>
              <div className="flex items-center gap-11 pr-4">
                {feature.currentUser ? <CheckIcon /> : <NotIncludedIcon />}
                {feature.plusVersion ? <CheckIcon /> : <NotIncludedIcon />}
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  )
}

interface ComparisonFeature {
  name: string
  currentUser: boolean
  plusVersion: boolean
}

const featuresForFreeUser: ComparisonFeature[] = [
  {
    name: m.focus_timer(),
    currentUser: true,
    plusVersion: true,
  },
  {
    name: m.triple_coin_reward(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.custom_app_allow_list(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.free_use_crystal_tree(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.focus_analysis(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.plant_tree_for_earth(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.no_ads(),
    currentUser: false,
    plusVersion: true,
  },
]

const featuresForProUser: ComparisonFeature[] = [
  {
    name: m.all_original_pro_features(),
    currentUser: true,
    plusVersion: true,
  },
  {
    name: m.triple_coin_reward(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.plus_exclusive_tree(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.seasonal_crystal_trees(),
    currentUser: false,
    plusVersion: true,
  },
  {
    name: m.app_block(),
    currentUser: false,
    plusVersion: true,
  },
]
